<template>
	<div>
		<router-link tag="div" :to="{path:'/ebook?id='+item.id}" class="bookItem radius10 cursor"
		 v-for="(item,index) in bookProp"
		 :key="index"
		 >
			<img :src="item.main_drawing_pc" width="210px" height="280px" alt="">
			<div class="tag">
				<div class="line1 fsmain fb fsm2 mb-5">{{item.name}}</div>
				<div class="color-main fsm2 fsmain mb-10"><b>￥{{item.price}}</b> <span class="fsmain">/{{item.score}}积分</span></div>
				<div class="color6">已售{{item.sales}}件</div>
			</div>
		</router-link>
	</div>
</template>

<script>
	export default{
		props: {
			isStatus: {
				type: Number, // 是否显示未开始 1显示  0不显示
				defult: 0// 默认不显示
			},
			bookProp: {
				type: Array,
				default: () => { return [] }
			}
		},
		data() {
			return {

			}
		}
	}
</script>

<style lang="less">
	.bookItem{
		width: 210px;
		background-color: #fff;
		display: inline-block;
		margin-right: 15px;
		border-radius: 8px;
		-webkit-border-radius: 8px;
		-moz-border-radius: 8px;
		overflow: hidden;
		box-shadow: 0 0 5px 1px #e5e5e5;
		.tag{
			padding: 10px 12px 15px;
		}
		&:hover{
			box-shadow: 0 0 5px 1px #cdcdcd;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Course/book.vue